import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { LogoOrMark } from './Lettermark';
import { getRecentSuppliers } from '../lib/recentlyViewed';

// Horizontal "jump back" strip of the suppliers the visitor recently viewed.
// `excludeSlug` hides the supplier currently being viewed.
export const RecentlyViewed = ({ excludeSlug, className = '' }) => {
  const items = getRecentSuppliers().filter((x) => x.slug !== excludeSlug);
  if (items.length === 0) return null;
  return (
    <div className={className} data-testid="recently-viewed">
      <div className="flex items-center gap-1.5 mb-3 text-sm font-semibold text-gray-500">
        <Clock className="w-4 h-4" /> Recently viewed
      </div>
      <div className="flex gap-3 overflow-x-auto pb-1 -mx-1 px-1">
        {items.map((s) => (
          <Link
            key={s.slug}
            to={`/suppliers/${s.slug}`}
            className="shrink-0 inline-flex items-center gap-2 bg-white border border-[#E5E7EB] rounded-full pl-2 pr-4 py-1.5 hover:border-[#00A79D] hover:shadow-sm transition-all"
            data-testid={`recent-supplier-${s.slug}`}
          >
            <LogoOrMark logo={s.logo} name={s.name} imgClassName="h-6 w-6 object-contain rounded" markClassName="h-6 w-6 text-[10px] rounded-full" />
            <span className="text-sm font-medium text-gray-800 whitespace-nowrap">{s.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};
